import { Navigate, Outlet, useParams } from "react-router";
import { isValidLang } from "@/config/routes";
import { useAuth } from "@/contexts/auth-context";

export function ProtectedRoute() {
	const { isAuthenticated, state } = useAuth();
	const { lang } = useParams<{ lang: string }>();
	const currentLang = lang && isValidLang(lang) ? lang : "pl";

	if (state.restoring) {
		return null;
	}

	if (!isAuthenticated) {
		return <Navigate to={`/${currentLang}/login`} replace />;
	}

	return <Outlet />;
}
